import { AppIcon } from "./app-icon";
import type { AppIdentity } from "./app-identity";
import { cn } from "./cn";

/**
 * Application identity as it appears inside tables and lists.
 *
 * The design took a `slug` and looked the application up in `lib/data`; this
 * takes the application itself, so a table can render a row whose application
 * the caller could not resolve by passing `undefined` and still getting the
 * em-dash the design drew.
 */
export function AppBadge({
  app,
  showSlug = false,
  size = "sm",
  className,
}: {
  app?: AppIdentity;
  showSlug?: boolean;
  size?: "sm" | "md";
  className?: string;
}) {
  if (!app) return <span className="text-ink-4">—</span>;

  return (
    <span className={cn("flex min-w-0 items-center gap-2.5", className)}>
      <AppIcon initial={app.initial} tone={app.tone} size={size} />
      <span className="min-w-0">
        <span className="block truncate font-semibold text-ink">{app.name}</span>
        {showSlug && app.slug ? (
          <span className="block truncate font-mono text-2xs text-ink-4">{app.slug}</span>
        ) : null}
      </span>
    </span>
  );
}
